import { defineStore } from 'pinia'
import apiService from '@/services/apiService';

export const useTextsStore = defineStore('texts', {
    state: () => ({
        loading: false,
        error: null,
        haveAQuestion: true,
        texts: [],
        availableAreas: []
    }),

    actions: {
        async fetchTexts() {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.get('/texts')
                this.texts = response.data
            } catch (err) {
                this.error = err
                console.error('Błąd przy pobieraniu tekstów:', err)
            } finally {
                this.loading = false
            }
        },

        async updateText(id, data) {
            this.loading = true
            this.error = null
            try {
                await apiService.post(`/texts/${id}`, data)
                await this.fetchTexts()
            } catch (err) {
                this.error = err
                console.error('Błąd przy aktualizacji tekstu:', err)
            } finally {
                this.loading = false
            }
        },
    },
})
